import { ShareContext } from "./contexts/ShareContext";
import usePrefetchData from "./hooks/usePrefetchData";
import useValidShareOptions from "./hooks/useValidShareOptions";
import { SharePayloadProp, ValidShareOption } from "./types";

export type ShareWrapperProps = SharePayloadProp & {
	renderItems?: (options: ValidShareOption[]) => React.ReactNode;
	onComplete?: () => void;
	onCopy?: () => void;
	onCopyClear?: () => void;
	onSuccess?: () => void;
	displayIconText?: boolean;
};

const ShareWrapper = ({
	data,
	renderItems,
	onComplete,
	onCopy,
	onCopyClear,
	onSuccess,
	displayIconText,
}: ShareWrapperProps) => {
	const prefetched = usePrefetchData(data);
	const options = useValidShareOptions(data);

	return (
		<ShareContext.Provider
			value={{
				prefetched,
				displayIconText,
				onComplete,
				onCopy,
				onCopyClear,
				onSuccess,
			}}
		>
			{renderItems?.(options)}
		</ShareContext.Provider>
	);
};
export default ShareWrapper;
